var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9 21.78L20.36 18.24C20.0796 17.9577 19.6979 17.7992 19.3 17.8C18.903 17.8036 18.5229 17.9613 18.24 18.24C19.3712 17.1196 20.0053 15.5921 20 14C20 10.6863 17.3137 8 14 8C10.6863 8 8 10.6863 8 14C8 17.3137 10.6863 20 14 20C15.5921 20.0053 17.1196 19.3712 18.24 18.24C17.6605 18.8279 17.6605 19.7721 18.24 20.36L21.78 23.9C22.0604 24.1823 22.4421 24.3408 22.84 24.34C23.2375 24.3386 23.6183 24.1805 23.9 23.9C24.1834 23.6201 24.3429 23.2383 24.3429 22.84C24.3429 22.4417 24.1834 22.0599 23.9 21.78ZM14 19C11.2386 19 9 16.7614 9 14C9 11.2386 11.2386 9 14 9C16.7614 9 19 11.2386 19 14C19 16.7614 16.7614 19 14 19ZM23.19 23.19C23.0983 23.2851 22.9721 23.3392 22.84 23.34C22.7074 23.3416 22.5803 23.2871 22.49 23.19L19 19.66C18.8732 19.5332 18.8236 19.3483 18.8701 19.1751C18.9165 19.0018 19.0518 18.8665 19.2251 18.8201C19.3983 18.7736 19.5832 18.8232 19.71 18.95L23.24 22.49C23.3371 22.5803 23.3916 22.7074 23.39 22.84C23.3766 22.98 23.3038 23.1074 23.19 23.19Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SearchIcon.bfd456c3161a16d8f2771f891e96fb47.svg";